import React, { useState, useEffect, useMemo } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Cookies from 'js-cookie';
import Typography from '@material-ui/core/Typography';
import moment from 'moment';
import EditNoteIcon from '@mui/icons-material/EditNote';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useTheme } from "@mui/material/styles";
import MenuIcon from '@mui/icons-material/Menu';
import DashboardIcon from '@mui/icons-material/Dashboard';
import { createTheme, ThemeProvider, CssBaseline } from "@mui/material";

import IconButton from '@material-ui/core/IconButton';
import { Drawer, List, ListItem, ListItemText, ListItemIcon, useMediaQuery } from '@mui/material';
import PostAddIcon from '@mui/icons-material/PostAdd';
import SettingsIcon from '@mui/icons-material/Settings';
import { Timeline } from 'rsuite';
import CreditCardIcon from '@rsuite/icons/legacy/CreditCard';
import PlaneIcon from '@rsuite/icons/legacy/Plane';
import TruckIcon from '@rsuite/icons/legacy/Truck';
import UserIcon from '@rsuite/icons/legacy/User';
import CheckIcon from '@rsuite/icons/legacy/Check';
import './Timeline.css';
import EditIcon from '@mui/icons-material/Edit';

import {
    MaterialReactTable,

} from 'material-react-table';
import Skeleton from '@material-ui/lab/Skeleton';
import EditTwoToneIcon from '@material-ui/icons/EditTwoTone';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';

import {
    Box,
    Tooltip
} from '@mui/material';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';

import api from '../../../../../../services/api';
import MenuRecursosAdministrativos from '../components/menu';
import NavegadorGestao from "../../../../../../components/NavBarGestao";

import Rodape from '../../../../../../components/Rodape';

import { Button, MenuItem, Select, InputLabel } from "@material-ui/core";
import Pagination from '@material-ui/lab/Pagination';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import { styled } from '@material-ui/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import AppBar from '@mui/material/AppBar';
import TextField from '@material-ui/core/TextField';
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

const drawerWidth = 240;



const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        '& .cabecalho_transparente': {
            backgroundColor: 'rgba(0, 0, 0, 0)',
            color: 'rgba(0, 0, 0, 0)',
        },
        '& .cabecalho_azul': {
            backgroundColor: 'rgba(0, 0, 255, 1)',
            color: 'white',
        },
        '& .cabecalho_verde': {
            backgroundColor: 'rgba(0, 100, 0, 1)',
            color: 'white',
        },
        '& .cabecalho_verde_claro': {
            backgroundColor: 'rgba(107,142,35, 1)',
            color: 'white',
        },
        '& .cabecalho_marrom_claro': {
            backgroundColor: 'rgba(184,134,11, 1)',
            color: 'white',
        },
        '& .cabecalho_verde_cyan': {
            backgroundColor: 'rgba(0,139,139, 1)',
            color: 'white',
        },
        '& .cabecalho_verde_dark_sea': {
            backgroundColor: 'rgba(60,179,113, 1)',
            color: 'white',
        },
        '& .cabecalho_marrom_escuro': {
            backgroundColor: 'rgba(139,69,19, 1)',
            color: 'white',
        },
        '& .cabecalho_marrom_chocolate': {
            backgroundColor: 'rgba(210,105,30, 1)',
            color: 'white',
        },
        '& .cabecalho_darkslate': {
            backgroundColor: 'rgba(47,79,79, 1)',
            color: 'white',
        },
        '& .super-app.negative': {
            backgroundColor: 'rgba(157, 255, 118, 0.49)',
            color: '#1a3e72',
            fontWeight: '600',
        },
        '& .super-app.positive': {
            backgroundColor: '#d47483',
            color: '#1a3e72',
            fontWeight: '600',
        },
        '& .super-app.neutro': {
            backgroundColor: '#363636',
            color: 'white',
            fontWeight: '600',
        },
    },
    toolbar: {
        paddingRight: 24, // keep right padding when drawer closed
    },
    toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    menuButtonHidden: {
        display: 'none',
    },
    title: {
        flexGrow: 1,
    },
    drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
        },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: 240,
    },
    table: {
        minWidth: 650,
    },
}));

const ColorButtonGreen = styled(Button)(({ theme }) => ({
    color: 'white',
    backgroundColor: 'green',
    borderColor: 'black',
    '&:hover': {
        backgroundColor: 'green',
        color: 'blue',
        borderColor: 'blue',
    },
}));


const ColorButtonRed = styled(Button)(({ theme }) => ({
    color: 'white',
    backgroundColor: 'red',
    borderColor: 'black',
    '&:hover': {
        backgroundColor: 'red',
        color: 'whit',
        borderColor: 'blue',
    },
}));

function novo() {
    window.location.href = "/gestao/operacional/almoxarifado/entradaestoque/cadastrarentradaestoque"

}

export default function EntradaEstoque() {
    const [value, setValue] = useState(1);

    const [tableHeight, setTableHeight] = useState(400); // valor inicial qualquer
    const [darkMode, setDarkMode] = useState(Cookies.get('darkMode') === 'true');


    useEffect(() => {
        const handleDarkModeChange = () => {
            const isDark = Cookies.get('darkMode') === 'true'; // Force dark on mobile
            setDarkMode(isDark);
        };

        window.addEventListener('darkModeChanged', handleDarkModeChange);

        // Inicializa estado
        const currentDarkMode = Cookies.get('darkMode') === 'true'; // Force dark on mobile
        setDarkMode(currentDarkMode);

        return () => {
            window.removeEventListener('darkModeChanged', handleDarkModeChange);
        };
    }, []);


    const tableTheme = createTheme({
        palette: {
            mode: darkMode ? 'dark' : 'light',
            ...(darkMode && {
                background: {
                    default: '#121212',
                    paper: '#1e1e1e',
                },
            }),
        },
        components: {
            MuiTablePagination: {
                styleOverrides: {
                    root: {
                        color: darkMode ? '#fff' : '#000',
                    },
                    selectLabel: {
                        color: darkMode ? '#fff' : '#000',
                    },
                    displayedRows: {
                        color: darkMode ? '#fff' : '#000',
                    },
                },
            },
            MuiSelect: {
                styleOverrides: {
                    icon: {
                        color: darkMode ? '#fff' : '#000',
                    },
                    select: {
                        color: darkMode ? '#fff' : '#000',
                    },
                },
            },
        },
    });


    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // mobile até sm
    const [open, setOpen] = useState(false);

    const toggleDrawer = () => {
        setOpen(!open);
    };

    const regra = Cookies.get("regra") || "";



    const handleMenuClick = (newValue) => {
        if (newValue === 0) {

        } else if (newValue === 1) {


            listar();
        } else if (newValue === 2) {


        }
        setValue(newValue);
    };



    const classes = useStyles();
    const [loading, setLoading] = useState(true);
    const [height, setHeight] = useState(0);

    const [objetos, setObjetos] = useState(null);
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 1000,
    });

    const [totalRegistros, setTotalRegistros] = useState(0);


    function formatDate(date) {
        // Formate a data para 'HH:mm DD/MMM/YYYY'
        return moment(date).format('HH:mm DD/MM/YYYY');
    }



    function checkDimenssoes() {

        var altura = window.innerHeight
            || document.documentElement.clientHeight
            || document.body.clientHeight;


        setHeight(altura * 0.75);

    }

    window.addEventListener('resize', function (event) {
        checkDimenssoes();
    });

    const [filtro, setFiltro] = useState("");




    async function listar() {

        setLoading(true);

        try {
            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            }


            await api.get(`v1/protected/almoxarifado/entradaestoque/listartodossimples?busca=${filtro}&size=${pagination.pageSize}&page=${pagination.pageIndex}`, {
                headers: headers
            }).then(function (response) {


                setObjetos(response.data.dados);
                setTotalRegistros(response.data.total);

                setLoading(false);


            });


        } catch (_err) {

            console.log("Erro ao listar objetos: " + _err)
            setLoading(false);

        }

    }


    useEffect(() => {


        checkDimenssoes();


        listar();


    }, []);






    const handleCellClick = (param, event) => {
        event.stopPropagation();
    };

    const handleRowClick = (param, event) => {
        event.stopPropagation();
    };



    function returnDescricaoFornecedor(fornecedor) {
        var texto = "Fornecedor_ID: " + fornecedor.id_fornecedor + "\nCPF/CNPJ: " + (fornecedor.tipo_fornecedor === 0 ? fornecedor.cpf : fornecedor.cnpj) +
            "\nNome/Nome Fantasia: " + (fornecedor.tipo_fornecedor === 0 ? (fornecedor.nome + " " + fornecedor.sobrenome) : fornecedor.nome_fantasia);

        return texto;
    }




    const handleClickEdicao = (row) => {
        window.open(
            "/gestao/operacional/almoxarifado/entradaestoque/gerenciarentradaestoque/" + row.id_entrada_estoque,
            "_blank",
            "noopener,noreferrer"
        );
    };




    const columns = useMemo(
        () => [
            {
                accessorKey: 'id_entrada_estoque',
                header: 'ID',
                size: 50,
            },

            {
                id: 'timeline',
                header: 'Linha do Tempo',
                size: 300,
                maxWidth: 300,
                accessorFn: row => ({
                    data_hora_criacao: row.data_criacao,
                    data_hora_conclusao: row.data_hora_conclusao,
                    status: row.status,
                    id_entrada_estoque: row.id_entrada_estoque,
                }),
                Cell: ({ renderedCellValue }) => {
                    const { data_hora_criacao, data_hora_conclusao, status } = renderedCellValue;

                    const criacao = moment(data_hora_criacao, 'YYYY-MM-DD HH:mm:ss').format('HH:mm DD/MM');
                    const conclusao = data_hora_conclusao
                        ? moment(data_hora_conclusao, 'YYYY-MM-DD HH:mm:ss').format('HH:mm DD/MM')
                        : '';

                    const concluido = status === 1;

                    return (
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            {/* Bloco de Criação */}
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '0 1rem' }}>
                                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                    {criacao}
                                </Typography>

                                <Box sx={{ height: '2px' }} />

                                <Box
                                    sx={{
                                        width: 32,
                                        height: 32,
                                        border: '2px solid green',
                                        borderRadius: '50%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <EditIcon sx={{ color: 'green', fontSize: 16 }} />
                                </Box>

                                <Typography variant="caption" sx={{ marginTop: '4px', fontWeight: 500 }}>
                                    Criado
                                </Typography>
                            </Box>

                            {/* Linha de conexão */}
                            <Box
                                sx={{
                                    width: 60,
                                    height: 3,
                                    marginTop: '1.5rem',
                                    background: concluido
                                        ? 'green'
                                        : 'linear-gradient(90deg, transparent, #ffcdd2, transparent)',
                                    animation: concluido ? 'none' : 'pulseLine 2s infinite ease-in-out',
                                    '@keyframes pulseLine': {
                                        '0%': {
                                            background: 'linear-gradient(90deg, transparent, #ffcdd2, transparent)',
                                        },
                                        '50%': {
                                            background: 'linear-gradient(90deg, transparent, #e57373, transparent)',
                                        },
                                        '100%': {
                                            background: 'linear-gradient(90deg, transparent, #ffcdd2, transparent)',
                                        },
                                    },
                                }}
                            />

                            {/* Bloco de Conclusão */}
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '0 1rem' }}>
                                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                    {concluido ? conclusao : 'Em andamento'}
                                </Typography>

                                <Box sx={{ height: '2px' }} />

                                <Box
                                    sx={{
                                        width: 32,
                                        height: 32,
                                        border: `2px solid ${concluido ? 'green' : '#e57373'}`,
                                        borderRadius: '50%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        backgroundColor: concluido ? 'transparent' : '#fce4ec',
                                        animation: concluido ? 'none' : 'pulseZoom 2s infinite ease-in-out',
                                        '@keyframes pulseZoom': {
                                            '0%': { backgroundColor: 'transparent', transform: 'scale(1)' },
                                            '50%': { backgroundColor: '#ffcdd2', transform: 'scale(1.3)' },
                                            '100%': { backgroundColor: 'transparent', transform: 'scale(1)' },
                                        },
                                    }}
                                >
                                    {concluido ? (
                                        <CheckCircleIcon sx={{ color: 'green', fontSize: 18 }} />
                                    ) : (
                                        <HourglassBottomIcon sx={{ color: '#e57373', fontSize: 18 }} />
                                    )}
                                </Box>

                                <Typography variant="caption" sx={{ marginTop: '4px', fontWeight: 500 }}>
                                    {concluido ? 'Concluído' : 'Em andamento'}
                                </Typography>
                            </Box>
                        </Box>
                    );
                },
            },
            {
                accessorFn: (row) => {
                    const pc = row.pre_cotacao;
                    const ordemCompra = row.ordem_compra;
                    if (!pc || !ordemCompra) return '';
                    return `O.C ${ordemCompra.id_ordem_compra}.${pc.id_pre_cotacao} - ${pc.nome_fornecedor_amigavel}`;
                },
                id: 'compra',
                header: 'Compra',
                size: 300,
                filterVariant: 'text',
                filterFn: 'contains',
                Cell: ({ row }) => {
                    const pc = row.original.pre_cotacao;
                    const ordemCompra = row.original.ordem_compra;
                    if (!pc || !ordemCompra) return null;

                    const idOrdemCompra = ordemCompra.id_ordem_compra;
                    const idPreCotacao = pc.id_pre_cotacao;
                    const nomeFornecedor = pc.nome_fornecedor_amigavel || '';

                    return (
                        <span style={{ fontSize: 12, color: darkMode ? '#fff' : 'black', display: 'flex', alignItems: 'center', gap: '8px' }}>
                            {idOrdemCompra > 0 && (
                                <Tooltip title="Abrir Ordem de Compra">
                                    <IconButton
                                        color="primary"
                                        size="small"
                                        onClick={() => window.open(`/gestao/administracao/ordensdecompras/editar/${idOrdemCompra}`, '_blank')}
                                    >
                                        <SettingsIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                            )}
                            {`O.C ${idOrdemCompra}.${idPreCotacao} - ${nomeFornecedor}`}

                        </span>
                    );
                },
            },

            {
                accessorFn: (row) => row.usuario_criador?.nome_amigavel || '',
                id: 'usuario',
                header: 'Usuário Criador',
                size: 130,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
            },
            {
                accessorKey: 'descricao',
                header: 'Descrição',
                size: 130,
            },


            {
                accessorKey: 'data_criacao',
                header: 'Data Criação',
                size: 130,
                Cell: ({ renderedCellValue }) => (
                    <span>{formatDate(renderedCellValue)}</span>
                ),
            },



        ],
        [darkMode],
    );



    return (
        <div style={{ backgroundColor: darkMode ? '#121212' : 'white', minHeight: '100vh', color: darkMode ? '#fff' : 'inherit' }}>
            {/* Navegador */}
            <NavegadorGestao
                Almoxarifado={true}
                OpEntrada={true}
                corFundo={darkMode ? '#1e1e1e' : 'white'}
                travado={true}
                corTexto={darkMode ? '#fff' : 'black'}
            />

            <div style={{ padding: 10, width: '100%', height: '100%' }}>
                {loading ? (
                    <Skeleton
                        animation="wave"
                        width={'100%'}
                        style={{ backgroundColor: '#48D1CC' }}
                    />
                ) : (
                    <div>


                        <div
                            style={{
                                paddingTop: 1,
                                overflow: 'hidden',
                                display: 'flex',
                                flexDirection: 'column',
                            }}
                        >

                            {objetos !== null && (
                                <ThemeProvider theme={tableTheme}>
                                    <CssBaseline />
                                    <MaterialReactTable
                                        columns={columns}
                                        data={objetos}
                                        enableBottomToolbar={!isMobile}
                                        enableGlobalFilterModes
                                        enablePagination={!isMobile}
                                        enableRowActions
                                        paginationDisplayMode="pages"
                                        manualPagination={true}
                                        rowCount={totalRegistros}
                                        state={{ pagination }}
                                        getRowId={(row) => row.id_entrada_estoque}
                                        enableGrouping
                                        initialState={{
                                            showGlobalFilter: true,
                                            showColumnFilters: !isMobile,
                                            columnVisibility: isMobile
                                                ? {
                                                    id_entrada_estoque: true,
                                                    status: true,
                                                    usuario: false,
                                                    descricao: false,
                                                    compra: false,
                                                    data_hora_conclusao: false,
                                                }
                                                : { nivel_prioridade: false },
                                        }}
                                        muiTableContainerProps={{
                                            sx: {
                                                flex: 1,
                                                overflowY: 'auto',
                                                overflowX: 'auto',
                                                height: 'calc(100vh - 200px)',
                                                backgroundColor: darkMode ? '#1e1e1e' : '#fff',
                                                '& thead': {
                                                    position: 'sticky',
                                                    top: 0,
                                                    backgroundColor: darkMode ? '#2d2d2d' : '#fff',
                                                    zIndex: 2,
                                                },
                                            },
                                        }}
                                        muiTablePaperProps={{
                                            sx: {
                                                backgroundColor: darkMode ? '#1e1e1e' : '#fff',
                                            },
                                        }}
                                        enableStickyHeader={!isMobile}
                                        muiTableHeadCellProps={{
                                            sx: {
                                                padding: '4px',
                                                fontSize: '0.75rem',
                                                lineHeight: 1,
                                                height: '28px',
                                                color: darkMode ? '#fff' : '#222',
                                                backgroundColor: darkMode ? '#2d2d2d' : 'inherit',
                                                display: isMobile ? 'none' : 'table-cell',
                                            },
                                        }}
                                        muiTableBodyCellProps={{
                                            sx: {
                                                padding: '4px',
                                                fontSize: '0.75rem',
                                                lineHeight: 1.2,
                                                color: darkMode ? '#fff' : '#222',
                                                backgroundColor: 'inherit',
                                            },
                                        }}

                                        muiTableBodyRowProps={({ row }) => ({
                                            sx: {
                                                height: '14px',
                                                backgroundColor: darkMode
                                                    ? (row.index % 2 === 0 ? '#1e1e1e' : '#2a2a2a')
                                                    : (row.index % 2 === 0 ? '#f9f9f9' : '#e0e0e0'),
                                                transition: 'background-color 0.3s',
                                                '&:hover': {
                                                    backgroundColor: darkMode ? '#333' : '#d0f0ff',
                                                },
                                            },
                                        })}

                                        enableFullScreenToggle={!isMobile}

                                        renderTopToolbarCustomActions={({ row }) => (
                                            <Box
                                                sx={{
                                                    flex: 1,
                                                    display: 'flex',
                                                    justifyContent: 'flex-end'
                                                }}
                                            >
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={() => novo()}
                                                >
                                                    Nova Entrada
                                                </Button>
                                            </Box>
                                        )}
                                        renderRowActions={({ row }) => (
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    gap: '1rem',
                                                    flexDirection: 'row',
                                                    alignItems: 'center',
                                                }}
                                            >
                                                <Tooltip title="Gerenciar">
                                                    <IconButton color="primary" onClick={() => handleClickEdicao(row.original)}>
                                                        <SettingsIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            </Box>
                                        )}
                                    />
                                </ThemeProvider>

                            )}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );

}



